import * as styled from '../styles/pill-tag';

type Props = {
  label: string;
  tone: 'success' | 'neutral';
};

export const PillTag = ({ label, tone }: Props) => <styled.Tag $tone={tone}>{label}</styled.Tag>;
